import { z } from 'zod';

export const isValidEmail = (email: string): boolean => {
  const emailSchema = z.string().email({ message: 'Invalid email address' });

  try {
    return !!emailSchema.parse(email);
  } catch (e) {
    return false;
  }
};
